import { useUrlOpenState } from '../common/use-url-params';

export const useStepupOpen = () => {
  return useUrlOpenState({
    defaultValue: {
      stepupModal: null,
    },
    paramName: 'stepupModal',
  });
};
